
// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Alert,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Tabs,
//   Tab,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { useNavigate, useLocation } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";

// const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
// const PHONE_REGEX = /^\+?[0-9]{10,14}$/; // fits CharField(max_length=15)

// const emptyErrors = {
//   username: "",
//   password: "",
//   first_name: "",
//   last_name: "",
//   phone_no: "",
//   api: "",
// };

// function Login() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const DJANGO_API = process.env.REACT_APP_API_DJANGO_URL;

//   // "login" | "signup"
//   const [mode, setMode] = useState("login");
//   const isSignup = mode === "signup";

//   const [formData, setFormData] = useState({
//     username: "", // email
//     password: "",
//     first_name: "",
//     last_name: "",
//     phone_no: "",
//   });

//   const [errors, setErrors] = useState(emptyErrors);
//   const [success, setSuccess] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);

//   // Session-expired popup
//   const [sessionDialog, setSessionDialog] = useState(false);

//   // Open the popup when SessionManager redirected here because of expiry
//   useEffect(() => {
//     if (location.state?.sessionExpired) {
//       setSessionDialog(true);
//       // clear the router state so the popup doesn't reappear on refresh
//       navigate(location.pathname, { replace: true, state: null });
//     }
//   }, [location.state, location.pathname, navigate]);

//   // ---------- Validation ----------
//   const validateField = (name, value, data = formData) => {
//     switch (name) {
//       case "username":
//         if (!value.trim()) return "Email is required";
//         if (!EMAIL_REGEX.test(value)) return "Enter a valid email address";
//         return "";
//       case "password":
//         if (!value.trim()) return "Password is required";
//         return "";
//       case "first_name":
//         return isSignup && !value.trim() ? "First name is required" : "";
//       case "last_name":
//         return isSignup && !value.trim() ? "Last name is required" : "";
//       case "phone_no":
//         if (!isSignup) return "";
//         if (!value.trim()) return "Phone number is required";
//         if (!PHONE_REGEX.test(value.trim()))
//           return "Enter a valid phone number (10-14 digits)";
//         return "";
//       default:
//         return "";
//     }
//   };

//   const validate = () => {
//     const fields = isSignup
//       ? ["first_name", "last_name", "username", "phone_no"]
//       : ["username", "password"];

//     const newErrors = { ...emptyErrors };
//     fields.forEach((f) => {
//       newErrors[f] = validateField(f, formData[f]);
//     });
//     setErrors(newErrors);
//     return fields.every((f) => !newErrors[f]);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     const updated = { ...formData, [name]: value };
//     setFormData(updated);

//     const newErrors = { ...errors, [name]: "", api: "" };

//     // live validation for email + signup-only fields
//     if (name === "username") newErrors.username = validateField(name, value);
//     if (isSignup && name === "phone_no")
//       newErrors.phone_no = validateField(name, value);
//     setErrors(newErrors);
//     setSuccess("");
//   };

//   const switchMode = (_, newMode) => {
//     setMode(newMode);
//     setErrors(emptyErrors);
//     setSuccess("");
//     setShowPassword(false);
//     setFormData((prev) => ({ ...prev, password: "" }));
//   };

//   // ---------- Login ----------
//   const fetchOrganization = async (token) => {
//     try {
//       const response = await fetch(`${DJANGO_API}/api/get_organization/`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const data = await response.json();
//       const customerId = data?.customers?.[0]?.id?.id;

//       if (customerId) {
//         localStorage.setItem("customer_id", customerId);
//       } else {
//         console.warn("No customer found in response");
//       }
//     } catch (error) {
//       console.error("Error fetching organization:", error);
//     }
//   };

//   const handleLogin = async () => {
//     const response = await fetch(`${DJANGO_API}/api/demo_login/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       // backend reads "email", not "username"
//       body: JSON.stringify({
//         email: formData.username.trim(),
//         password: formData.password,
//       }),
//     });

//     const data = await response.json();

//     if (!response.ok) {
//       setErrors((prev) => ({
//         ...prev,
//         api: data?.message || data?.error || "Invalid credentials",
//       }));
//       return;
//     }

//     const token = data.token;
//     if (!token) {
//       setErrors((prev) => ({ ...prev, api: "Token not received" }));
//       return;
//     }

//     localStorage.setItem("accessToken", token);

//     // session token + expiry used by SessionManager
//     if (data.session_token) {
//       localStorage.setItem("session_token", data.session_token);
//     }
//     if (data.expires_at) {
//       localStorage.setItem("session_expires_at", data.expires_at);
//     }

//     const decoded = jwtDecode(token);
//     localStorage.setItem("refreshToken", data.refreshToken);
//     // only save if present, so "undefined" is never stored
//     if (decoded.customerId) {
//       localStorage.setItem("customer_id", decoded.customerId);
//     }
//     localStorage.setItem("tenantId", decoded.tenantId);
//     localStorage.setItem("userId", decoded.userId);
//     localStorage.setItem("userName", decoded.sub);
//     await fetchOrganization(token);

//     if (data.U_Type) {
//       localStorage.setItem("role", data.U_Type);
//     }

//     navigate("/dashboard");
//   };

//   // ---------- Sign Up ----------
//   const handleSignup = async () => {
//     // Payload keys must match what the Django register view expects
//     const response = await fetch(`${DJANGO_API}/api/register/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         email: formData.username.trim(),
//         first_name: formData.first_name.trim(),
//         last_name: formData.last_name.trim(),
//         phone: formData.phone_no.trim(),
//       }),
//     });

//     let data = {};
//     try {
//       data = await response.json();
//     } catch (_) {
//       // response had no JSON body
//     }

//     if (!response.ok) {
//       // Field-level errors from DRF, e.g. { email: ["..."], phone_no: ["..."] }
//       const fieldErrors = {};
//       if (data?.email) fieldErrors.username = [].concat(data.email).join(" ");
//       if (data?.first_name)
//         fieldErrors.first_name = [].concat(data.first_name).join(" ");
//       if (data?.last_name)
//         fieldErrors.last_name = [].concat(data.last_name).join(" ");
//       const phoneErr = data?.phone || data?.phone_no;
//       if (phoneErr) fieldErrors.phone_no = [].concat(phoneErr).join(" ");

//       setErrors((prev) => ({
//         ...prev,
//         ...fieldErrors,
//         api:
//           data?.message ||
//           data?.error ||
//           data?.detail ||
//           (Object.keys(fieldErrors).length ? "" : "Registration failed"),
//       }));
//       return;
//     }

//     // Success -> go back to Login with the email prefilled
//     setMode("login");
//     setSuccess(
//       "Registered successfully! Your login credentials have been sent to your email."
//     );
//     setFormData((prev) => ({
//       ...prev,
//       password: "",
//       first_name: "",
//       last_name: "",
//       phone_no: "",
//     }));
//     setErrors(emptyErrors);
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validate()) return;
//     setLoading(true);
//     setSuccess("");

//     try {
//       if (isSignup) {
//         await handleSignup();
//       } else {
//         await handleLogin();
//       }
//     } catch (error) {
//       setErrors((prev) => ({ ...prev, api: "Unable to connect to server" }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fieldSx = { mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } };

//   const passwordAdornment = (visible, toggle) => ({
//     endAdornment: (
//       <InputAdornment position="end">
//         <IconButton onClick={toggle} edge="end">
//           {visible ? <VisibilityOff /> : <Visibility />}
//         </IconButton>
//       </InputAdornment>
//     ),
//   });

//   // ---------- UI ----------
//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         padding: 2,
//       }}
//     >
//       {/* Session expired popup */}
//       <Dialog
//         open={sessionDialog}
//         onClose={() => setSessionDialog(false)}
//         PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
//       >
//         <DialogTitle sx={{ fontWeight: 700 }}>Session expired</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Your session has expired.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             variant="contained"
//             onClick={() => setSessionDialog(false)}
//             autoFocus
//             sx={{ textTransform: "none", borderRadius: 2 }}
//           >
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Paper
//         elevation={20}
//         sx={{
//           width: "100%",
//           maxWidth: 440,
//           p: 3,
//           borderRadius: 4,
//           textAlign: "center",
//           bgcolor: "rgba(255, 255, 255, 0.9)",
//           backdropFilter: "blur(10px)",
//         }}
//       >
//         <Box sx={{ textAlign: "center", mb: 2 }}>
//           <img
//             src={process.env.PUBLIC_URL + "/IgnisVigilLogo_1.png"}
//             alt="Ignis Vigil Logo"
//             style={{
//               width: "200px",
//               height: "100px",
//               objectFit: "cover",
//               objectPosition: "center",
//             }}
//           />
//         </Box>

//         <Typography variant="h6" fontWeight="700" sx={{ mt: 2, mb: 2 }}>
//           IoT & Smart Fire Fighting Systems Monitoring
//         </Typography>

//         {/* Login / Register switch */}
//         <Tabs
//           value={mode}
//           onChange={switchMode}
//           variant="fullWidth"
//           sx={{
//             mb: 3,
//             borderBottom: 1,
//             borderColor: "divider",
//             "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
//           }}
//         >

//           <Tab value="signup" label="Register" />
//           <Tab value="login" label="Login" />
//         </Tabs>

//         {success && (
//           <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }}>
//             {success}
//           </Alert>
//         )}

//         {errors.api && (
//           <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
//             {errors.api}
//           </Alert>
//         )}

//         <form onSubmit={handleSubmit} noValidate>
//           {isSignup && (
//             <Box sx={{ display: "flex", gap: 2 }}>
//               <TextField
//                 fullWidth
//                 label="First name"
//                 name="first_name"
//                 value={formData.first_name}
//                 onChange={handleChange}
//                 error={!!errors.first_name}
//                 helperText={errors.first_name}
//                 inputProps={{ maxLength: 100 }}
//                 sx={fieldSx}
//               />
//               <TextField
//                 fullWidth
//                 label="Last name"
//                 name="last_name"
//                 value={formData.last_name}
//                 onChange={handleChange}
//                 error={!!errors.last_name}
//                 helperText={errors.last_name}
//                 inputProps={{ maxLength: 100 }}
//                 sx={fieldSx}
//               />
//             </Box>
//           )}

//           <TextField
//             fullWidth
//             label="Email"
//             name="username"
//             variant="outlined"
//             value={formData.username}
//             onChange={handleChange}
//             error={!!errors.username}
//             helperText={errors.username}
//             sx={fieldSx}
//           />

//           {isSignup && (
//             <TextField
//               fullWidth
//               label="Phone number"
//               name="phone_no"
//               value={formData.phone_no}
//               onChange={handleChange}
//               error={!!errors.phone_no}
//               helperText={errors.phone_no}
//               inputProps={{ maxLength: 15, inputMode: "tel" }}
//               sx={fieldSx}
//             />
//           )}

//           {!isSignup && (
//             <TextField
//               fullWidth
//               label="Password"
//               name="password"
//               type={showPassword ? "text" : "password"}
//               value={formData.password}
//               onChange={handleChange}
//               error={!!errors.password}
//               helperText={errors.password}
//               sx={{ ...fieldSx, mb: 1 }}
//               InputProps={passwordAdornment(showPassword, () =>
//                 setShowPassword(!showPassword)
//               )}
//             />
//           )}

//           {!isSignup && (
//             <Typography
//               variant="caption"
//               sx={{
//                 display: "block",
//                 textAlign: "right",
//                 mb: 3,
//                 cursor: "pointer",
//                 color: "primary.main",
//                 fontWeight: 600,
//               }}
//             >
//               Forgot password?
//             </Typography>
//           )}

//           <Button
//             fullWidth
//             variant="contained"
//             type="submit"
//             disabled={loading}
//             sx={{
//               py: 1.5,
//               borderRadius: 2,
//               textTransform: "none",
//               fontSize: "1rem",
//               fontWeight: 600,
//               boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
//               transition: "all 0.3s ease",
//               "&:hover": {
//                 transform: "translateY(-2px)",
//                 boxShadow: "0px 12px 20px rgba(0, 0, 0, 0.15)",
//               },
//             }}
//           >
//             {loading
//               ? isSignup
//                 ? "Creating account..."
//                 : "Verifying..."
//               : isSignup
//               ? "Register"
//               : "Login"}
//           </Button>
//         </form>

//         <Typography variant="body2" sx={{ mt: 3, color: "text.secondary" }}>
//           {isSignup ? "Already have an account? " : "New here? "}
//           <Box
//             component="span"
//             onClick={() => switchMode(null, isSignup ? "login" : "signup")}
//             sx={{ color: "primary.main", fontWeight: 600, cursor: "pointer" }}
//           >
//             {isSignup ? "Login" : "Register"}
//           </Box>
//         </Typography>
//       </Paper>
//     </Box>
//   );
// }

// export default Login;



// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Alert,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Tabs,
//   Tab,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { useNavigate, useLocation } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";

// const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
// const PHONE_REGEX = /^\+?[0-9]{10,14}$/; // fits CharField(max_length=15)
// const OTP_RESEND_SECONDS = 60;

// const emptyErrors = {
//   username: "",
//   password: "",
//   first_name: "",
//   last_name: "",
//   phone_no: "",
//   api: "",
// };

// function Login() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const DJANGO_API = process.env.REACT_APP_API_DJANGO_URL;

//   // "login" | "signup" | "otp"
//   const [mode, setMode] = useState("login");
//   const isSignup = mode === "signup";
//   const isOtp = mode === "otp";

//   const [formData, setFormData] = useState({
//     username: "", // email
//     password: "",
//     first_name: "",
//     last_name: "",
//     phone_no: "",
//   });

//   const [errors, setErrors] = useState(emptyErrors);
//   const [success, setSuccess] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);

//   // OTP state
//   const [otp, setOtp] = useState("");
//   const [cooldown, setCooldown] = useState(0);

//   // Session-expired popup
//   const [sessionDialog, setSessionDialog] = useState(false);
//     // 24-hour login link state
//   const [linkInactive, setLinkInactive] = useState(false);
//   const [verifyingLink, setVerifyingLink] = useState(
//     () => !!new URLSearchParams(window.location.search).get("token")
//   );

//   // Open the popup when SessionManager redirected here because of expiry
//   useEffect(() => {
//     if (location.state?.sessionExpired) {
//       setSessionDialog(true);
//       // clear the router state so the popup doesn't reappear on refresh
//       navigate(location.pathname, { replace: true, state: null });
//     }
//   }, [location.state, location.pathname, navigate]);

//   // Resend countdown
//   useEffect(() => {
//     if (cooldown <= 0) return undefined;
//     const t = setTimeout(() => setCooldown((c) => c - 1), 1000);
//     return () => clearTimeout(t);
//   }, [cooldown]);




//   // Verify the 24-hour login link (?token=...)
//   useEffect(() => {
//     const token = new URLSearchParams(location.search).get("token");
//     if (!token) return;

//     const verifyLink = async () => {
//       try {
//         const response = await fetch(
//           `${DJANGO_API}/api/verify_login_link/?token=${encodeURIComponent(token)}`
//         );
//         const data = await response.json().catch(() => ({}));

//         if (response.ok && data.valid) {
//           setMode("login");
//           setFormData((prev) => ({ ...prev, username: data.email }));
//         } else {
//           setLinkInactive(true); // expired or invalid
//         }
//       } catch (error) {
//         setLinkInactive(true);
//       } finally {
//         setVerifyingLink(false);
//       }
//     };

//     verifyLink();
//   }, [location.search, DJANGO_API]);

//   // ---------- Validation ----------
//   const validateField = (name, value, data = formData) => {
//     switch (name) {
//       case "username":
//         if (!value.trim()) return "Email is required";
//         if (!EMAIL_REGEX.test(value)) return "Enter a valid email address";
//         return "";
//       case "password":
//         if (!value.trim()) return "Password is required";
//         return "";
//       case "first_name":
//         return isSignup && !value.trim() ? "First name is required" : "";
//       case "last_name":
//         return isSignup && !value.trim() ? "Last name is required" : "";
//       case "phone_no":
//         if (!isSignup) return "";
//         if (!value.trim()) return "Phone number is required";
//         if (!PHONE_REGEX.test(value.trim()))
//           return "Enter a valid phone number (10-14 digits)";
//         return "";
//       default:
//         return "";
//     }
//   };

//   const validate = () => {
//     const fields = isSignup
//       ? ["first_name", "last_name", "username", "phone_no"]
//       : ["username", "password"];

//     const newErrors = { ...emptyErrors };
//     fields.forEach((f) => {
//       newErrors[f] = validateField(f, formData[f]);
//     });
//     setErrors(newErrors);
//     return fields.every((f) => !newErrors[f]);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     const updated = { ...formData, [name]: value };
//     setFormData(updated);

//     const newErrors = { ...errors, [name]: "", api: "" };

//     // live validation for email + signup-only fields
//     if (name === "username") newErrors.username = validateField(name, value);
//     if (isSignup && name === "phone_no")
//       newErrors.phone_no = validateField(name, value);
//     setErrors(newErrors);
//     setSuccess("");
//   };

//   const switchMode = (_, newMode) => {
//     setMode(newMode);
//     setErrors(emptyErrors);
//     setSuccess("");
//     setShowPassword(false);
//     setOtp("");
//     setFormData((prev) => ({ ...prev, password: "" }));
//   };

//   // ---------- Login ----------
//   const fetchOrganization = async (token) => {
//     try {
//       const response = await fetch(`${DJANGO_API}/api/get_organization/`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const data = await response.json();
//       const customerId = data?.customers?.[0]?.id?.id;

//       if (customerId) {
//         localStorage.setItem("customer_id", customerId);
//       } else {
//         console.warn("No customer found in response");
//       }
//     } catch (error) {
//       console.error("Error fetching organization:", error);
//     }
//   };

//   const handleLogin = async () => {
//     const response = await fetch(`${DJANGO_API}/api/demo_login/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       // backend reads "email", not "username"
//       body: JSON.stringify({
//         email: formData.username.trim(),
//         password: formData.password,
//       }),
//     });

//     const data = await response.json();

//     if (!response.ok) {
//       setErrors((prev) => ({
//         ...prev,
//         api: data?.message || data?.error || "Invalid credentials",
//       }));
//       return;
//     }

//     const token = data.token;
//     if (!token) {
//       setErrors((prev) => ({ ...prev, api: "Token not received" }));
//       return;
//     }

//     localStorage.setItem("accessToken", token);

//     // session token + expiry used by SessionManager
//     if (data.session_token) {
//       localStorage.setItem("session_token", data.session_token);
//     }
//     if (data.expires_at) {
//       localStorage.setItem("session_expires_at", data.expires_at);
//     }

//     const decoded = jwtDecode(token);
//     localStorage.setItem("refreshToken", data.refreshToken);
//     // only save if present, so "undefined" is never stored
//     if (decoded.customerId) {
//       localStorage.setItem("customer_id", decoded.customerId);
//     }
//     localStorage.setItem("tenantId", decoded.tenantId);
//     localStorage.setItem("userId", decoded.userId);
//     localStorage.setItem("userName", decoded.sub);
//     await fetchOrganization(token);

//     if (data.U_Type) {
//       localStorage.setItem("role", data.U_Type);
//     }

//      localStorage.setItem("session_welcome", "true"); // <-- ADD


//     navigate("/dashboard");
//   };

//   // ---------- Sign Up: step 1 - send OTP ----------
//   const handleSignup = async () => {
//     const response = await fetch(`${DJANGO_API}/api/send_otp/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         email: formData.username.trim(),
//         mobile: formData.phone_no.trim(),
//         name: formData.first_name.trim()
//       }),
//     });

//     const data = await response.json().catch(() => ({}));

//     if (!response.ok) {
//       const isConflict = response.status === 409;
//       setErrors((prev) => ({
//         ...prev,
//         username: isConflict && data?.field !== "phone" ? data?.error || "" : "",
//         phone_no: isConflict && data?.field === "phone" ? data?.error || "" : "",
//         api: isConflict ? "" : data?.error || "Could not send OTP",
//       }));
//       return;
//     }

//     setOtp("");
//     setCooldown(OTP_RESEND_SECONDS);
//     setMode("otp");
//     setErrors(emptyErrors);
//     setSuccess(`We sent a 4-digit code to ${formData.phone_no.trim()}`);
//   };

//   // ---------- Sign Up: step 2 - verify OTP ----------
//   const handleVerifyOtp = async () => {
//     const response = await fetch(`${DJANGO_API}/api/verify_otp/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ mobile: formData.phone_no.trim(), otp }),
//     });

//     const data = await response.json().catch(() => ({}));

//     if (!response.ok) {
//       setErrors((prev) => ({
//         ...prev,
//         api: data?.error || "Verification failed",
//       }));
//       return;
//     }

//     // Email verified -> create the account
//     await registerUser();
//   };

//   // ---------- Sign Up: step 3 - create the account ----------
//   const registerUser = async () => {
//     // Payload keys must match what the Django register view expects
//     const response = await fetch(`${DJANGO_API}/api/register/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         email: formData.username.trim(),
//         first_name: formData.first_name.trim(),
//         last_name: formData.last_name.trim(),
//         phone: formData.phone_no.trim(),
//       }),
//     });

//     let data = {};
//     try {
//       data = await response.json();
//     } catch (_) {
//       // response had no JSON body
//     }

//     if (!response.ok) {
//       // Backend returns { errors: { email: "...", phone: "..." } }
//       const errs = data?.errors || {};
//       const fieldErrors = {};
//       if (errs.email) fieldErrors.username = [].concat(errs.email).join(" ");
//       if (errs.first_name)
//         fieldErrors.first_name = [].concat(errs.first_name).join(" ");
//       if (errs.last_name)
//         fieldErrors.last_name = [].concat(errs.last_name).join(" ");
//       const phoneErr = errs.phone || errs.phone_no;
//       if (phoneErr) fieldErrors.phone_no = [].concat(phoneErr).join(" ");

//       // go back to the form so field errors are visible
//       setMode("signup");
//       setOtp("");
//       setSuccess("");
//       setErrors((prev) => ({
//         ...prev,
//         ...fieldErrors,
//         api:
//           data?.message ||
//           data?.error ||
//           data?.detail ||
//           (Object.keys(fieldErrors).length ? "" : "Registration failed"),
//       }));
//       return;
//     }

//     // Success -> go back to Login with the email prefilled
//     setMode("login");
//     setOtp("");
//     setSuccess(
//       "Your Registration Succeeded! And demo portal login credentials has been sent to your email."
//     );
//     setFormData((prev) => ({
//       ...prev,
//       password: "",
//       first_name: "",
//       last_name: "",
//       phone_no: "",
//     }));
//     setErrors(emptyErrors);
//   };

//   // ---------- Resend OTP ----------
//   const handleResendOtp = async () => {
//     if (cooldown > 0 || loading) return;
//     setErrors(emptyErrors);
//     setSuccess("");
//     setLoading(true);

//     try {
//       const response = await fetch(`${DJANGO_API}/api/resend_otp/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           mobile: formData.phone_no.trim(),
//           name: formData.first_name.trim(),
//         }),
//       });
//       const data = await response.json().catch(() => ({}));

//       if (!response.ok) {
//         setErrors((prev) => ({
//           ...prev,
//           api: data?.error || "Could not resend OTP",
//         }));
//         return;
//       }

//       setOtp("");
//       setCooldown(OTP_RESEND_SECONDS);
//       setSuccess("A new code has been sent to your phone");
//     } catch (error) {
//       setErrors((prev) => ({ ...prev, api: "Unable to connect to server" }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (isOtp) {
//       if (!/^\d{4}$/.test(otp)) {
//         setErrors((prev) => ({ ...prev, api: "Enter the 4-digit code" }));
//         return;
//       }
//     } else if (!validate()) {
//       return;
//     }

//     setLoading(true);
//     setSuccess("");

//     try {
//       if (isOtp) {
//         await handleVerifyOtp();
//       } else if (isSignup) {
//         await handleSignup();
//       } else {
//         await handleLogin();
//       }
//     } catch (error) {
//       setErrors((prev) => ({ ...prev, api: "Unable to connect to server" }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fieldSx = { mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } };

//   const passwordAdornment = (visible, toggle) => ({
//     endAdornment: (
//       <InputAdornment position="end">
//         <IconButton onClick={toggle} edge="end">
//           {visible ? <VisibilityOff /> : <Visibility />}
//         </IconButton>
//       </InputAdornment>
//     ),
//   });

//   const submitLabel = () => {
//     if (isOtp) return loading ? "Verifying..." : "Verify & register";
//     if (isSignup) return loading ? "Sending OTP..." : "Send OTP";
//     return loading ? "Verifying..." : "Login";
//   };




//     if (verifyingLink) return null;

//   if (linkInactive) {
//     return (
//       <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//           padding: 2,
//         }}
//       >
//         <Paper
//           elevation={20}
//           sx={{
//             width: "100%",
//             maxWidth: 440,
//             p: 4,
//             borderRadius: 4,
//             textAlign: "center",
//             bgcolor: "rgba(255, 255, 255, 0.9)",
//           }}
//         >
//           <img
//             src={process.env.PUBLIC_URL + "/IgnisVigilLogo_1.png"}
//             alt="Ignis Vigil Logo"
//             style={{ width: "200px", height: "100px", objectFit: "cover" }}
//           />
//           <Typography variant="h6" fontWeight="700" sx={{ mt: 2, mb: 1 }}>
//             This link is not active now
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             This login link has expired. For further assistance, please contact
//             our Sales Team.
//           </Typography>
//         </Paper>
//       </Box>
//     );
//   }

//   // ---------- UI ----------
//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         padding: 2,
//       }}
//     >
//       {/* Session expired popup */}
//       <Dialog
//         open={sessionDialog}
//         onClose={() => setSessionDialog(false)}
//         PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
//       >
//         <DialogTitle sx={{ fontWeight: 700 }}>Session expired</DialogTitle>
//         <DialogContent>
//           <DialogContentText>Your session is expired. Thank you for showing interest in our Demo. For further assistance contact to our Sales Team.</DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             variant="contained"
//             onClick={() => setSessionDialog(false)}
//             autoFocus
//             sx={{ textTransform: "none", borderRadius: 2 }}
//           >
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Paper
//         elevation={20}
//         sx={{
//           width: "100%",
//           maxWidth: 440,
//           p: 3,
//           borderRadius: 4,
//           textAlign: "center",
//           bgcolor: "rgba(255, 255, 255, 0.9)",
//           backdropFilter: "blur(10px)",
//         }}
//       >
//         <Box sx={{ textAlign: "center", mb: 2 }}>
//           <img
//             src={process.env.PUBLIC_URL + "/IgnisVigilLogo_1.png"}
//             alt="Ignis Vigil Logo"
//             style={{
//               width: "200px",
//               height: "100px",
//               objectFit: "cover",
//               objectPosition: "center",
//             }}
//           />
//         </Box>

//         <Typography variant="h6" fontWeight="700" sx={{ mt: 2, mb: 2 }}>
//           IoT & Smart Fire Fighting Systems Monitoring
//         </Typography>

//         {/* Login / Register switch (hidden while entering the OTP) */}
//         {!isOtp && (
//           <Tabs
//             value={mode}
//             onChange={switchMode}
//             variant="fullWidth"
//             sx={{
//               mb: 3,
//               borderBottom: 1,
//               borderColor: "divider",
//               "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
//             }}
//           >
//             <Tab value="signup" label="Register" />
//             <Tab value="login" label="Login" />
//           </Tabs>
//         )}

//         {isOtp && (
//           <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 2 }}>
//             Verify your OTP
//           </Typography>
//         )}

//         {success && (
//           <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }}>
//             {success}
//           </Alert>
//         )}

//         {errors.api && (
//           <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
//             {errors.api}
//           </Alert>
//         )}

//         <form onSubmit={handleSubmit} noValidate>
//           {isOtp ? (
//             <>
//               <TextField
//                 fullWidth
//                 label="Enter 4-digit code"
//                 name="otp"
//                 value={otp}
//                 onChange={(e) => {
//                   setOtp(e.target.value.replace(/\D/g, "").slice(0, 4));
//                   setErrors((prev) => ({ ...prev, api: "" }));
//                 }}
//                 inputProps={{
//                   inputMode: "numeric",
//                   autoComplete: "one-time-code",
//                   maxLength: 4,
//                   style: {
//                     letterSpacing: 8,
//                     textAlign: "center",
//                     fontSize: 22,
//                   },
//                 }}
//                 autoFocus
//                 sx={fieldSx}
//               />

//               <Typography
//                 variant="body2"
//                 sx={{ mb: 3, color: "text.secondary" }}
//               >
//                 {cooldown > 0 ? (
//                   `Resend code in ${cooldown}s`
//                 ) : (
//                   <Box
//                     component="span"
//                     onClick={handleResendOtp}
//                     sx={{
//                       color: "primary.main",
//                       fontWeight: 600,
//                       cursor: "pointer",
//                     }}
//                   >
//                     Resend code
//                   </Box>
//                 )}
//               </Typography>
//             </>
//           ) : (
//             <>
//               {isSignup && (
//                 <Box sx={{ display: "flex", gap: 2 }}>
//                   <TextField
//                     fullWidth
//                     label="First name"
//                     name="first_name"
//                     value={formData.first_name}
//                     onChange={handleChange}
//                     error={!!errors.first_name}
//                     helperText={errors.first_name}
//                     inputProps={{ maxLength: 100 }}
//                     sx={fieldSx}
//                   />
//                   <TextField
//                     fullWidth
//                     label="Last name"
//                     name="last_name"
//                     value={formData.last_name}
//                     onChange={handleChange}
//                     error={!!errors.last_name}
//                     helperText={errors.last_name}
//                     inputProps={{ maxLength: 100 }}
//                     sx={fieldSx}
//                   />
//                 </Box>
//               )}

//               <TextField
//                 fullWidth
//                 label="Email"
//                 name="username"
//                 variant="outlined"
//                 value={formData.username}
//                 onChange={handleChange}
//                 error={!!errors.username}
//                 helperText={errors.username}
//                 sx={fieldSx}
//               />

//               {isSignup && (
//                 <TextField
//                   fullWidth
//                   label="Phone number"
//                   name="phone_no"
//                   value={formData.phone_no}
//                   onChange={handleChange}
//                   error={!!errors.phone_no}
//                   helperText={errors.phone_no}
//                   inputProps={{ maxLength: 15, inputMode: "tel" }}
//                   sx={fieldSx}
//                 />
//               )}

//               {!isSignup && (
//                 <TextField
//                   fullWidth
//                   label="Password"
//                   name="password"
//                   type={showPassword ? "text" : "password"}
//                   value={formData.password}
//                   onChange={handleChange}
//                   error={!!errors.password}
//                   helperText={errors.password}
//                   sx={{ ...fieldSx, mb: 1 }}
//                   InputProps={passwordAdornment(showPassword, () =>
//                     setShowPassword(!showPassword)
//                   )}
//                 />
//               )}

//               {!isSignup && (
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     display: "block",
//                     textAlign: "right",
//                     mb: 3,
//                     cursor: "pointer",
//                     color: "primary.main",
//                     fontWeight: 600,
//                   }}
//                 >
//                   Forgot password?
//                 </Typography>
//               )}
//             </>
//           )}

//           <Button
//             fullWidth
//             variant="contained"
//             type="submit"
//             disabled={loading}
//             sx={{
//               py: 1.5,
//               borderRadius: 2,
//               textTransform: "none",
//               fontSize: "1rem",
//               fontWeight: 600,
//               boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
//               transition: "all 0.3s ease",
//               "&:hover": {
//                 transform: "translateY(-2px)",
//                 boxShadow: "0px 12px 20px rgba(0, 0, 0, 0.15)",
//               },
//             }}
//           >
//             {submitLabel()}
//           </Button>
//         </form>

//         {isOtp ? (
//           <Typography variant="body2" sx={{ mt: 3, color: "text.secondary" }}>
//             Wrong number?{" "}
//             <Box
//               component="span"
//               onClick={() => switchMode(null, "signup")}
//               sx={{ color: "primary.main", fontWeight: 600, cursor: "pointer" }}
//             >
//               Go back
//             </Box>
//           </Typography>
//         ) : (
//           <Typography variant="body2" sx={{ mt: 3, color: "text.secondary" }}>
//             {isSignup ? "Already have an account? " : "New here? "}
//             <Box
//               component="span"
//               onClick={() => switchMode(null, isSignup ? "login" : "signup")}
//               sx={{ color: "primary.main", fontWeight: 600, cursor: "pointer" }}
//             >
//               {isSignup ? "Login" : "Register"}
//             </Box>
//           </Typography>
//         )}
//       </Paper>
//     </Box>
//   );
// }

// export default Login;





// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   Alert,
//   IconButton,
//   InputAdornment,
//   Paper,
//   Tabs,
//   Tab,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   MenuItem,
// } from "@mui/material";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import { useNavigate, useLocation } from "react-router-dom";
// import { jwtDecode } from "jwt-decode";

// const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
// const PHONE_REGEX = /^\+?[0-9]{10,14}$/; // fits CharField(max_length=15)
// const OTP_RESEND_SECONDS = 60;

// const ORG_TYPES = [
//   "Builder",
//   "MEP Consultant",
//   "System Integrator",
//   "Supplier",
//   "Auditor",
// ];
// const PRIORITIES = ["Immediate", "Within 1 Month", "Within 3 Months"];
// const REFERENCES = ["Internet", "WhatsApp", "Person"];

// const emptyErrors = {
//   username: "",
//   password: "",
//   first_name: "",
//   last_name: "",
//   phone_no: "",
//   company_name: "",
//   organization_type: "",
//   company_address: "",
//   implementation_priority: "",
//   reference_by: "",
//   reference_person_name: "",
//   reference_person_mobile: "",
//   api: "",
// };

// const emptyForm = {
//   username: "", // email
//   password: "",
//   first_name: "",
//   last_name: "",
//   phone_no: "",
//   company_name: "",
//   organization_type: "",
//   company_address: "",
//   implementation_priority: "",
//   reference_by: "",
//   reference_person_name: "",
//   reference_person_mobile: "",
// };

// function Login() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const DJANGO_API = process.env.REACT_APP_API_DJANGO_URL;

//   // "login" | "signup" | "otp"
//   const [mode, setMode] = useState("login");
//   const isSignup = mode === "signup";
//   const isOtp = mode === "otp";

//   const [formData, setFormData] = useState(emptyForm);

//   const [errors, setErrors] = useState(emptyErrors);
//   const [success, setSuccess] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [showPassword, setShowPassword] = useState(false);

//   // OTP state
//   const [otp, setOtp] = useState("");
//   const [cooldown, setCooldown] = useState(0);

//   // Session-expired popup
//   const [sessionDialog, setSessionDialog] = useState(false);
//   // 24-hour login link state
//   const [linkInactive, setLinkInactive] = useState(false);
//   const [verifyingLink, setVerifyingLink] = useState(
//     () => !!new URLSearchParams(window.location.search).get("token")
//   );

//   // Open the popup when SessionManager redirected here because of expiry
//   useEffect(() => {
//     if (location.state?.sessionExpired) {
//       setSessionDialog(true);
//       // clear the router state so the popup doesn't reappear on refresh
//       navigate(location.pathname, { replace: true, state: null });
//     }
//   }, [location.state, location.pathname, navigate]);

//   // Resend countdown
//   useEffect(() => {
//     if (cooldown <= 0) return undefined;
//     const t = setTimeout(() => setCooldown((c) => c - 1), 1000);
//     return () => clearTimeout(t);
//   }, [cooldown]);

//   // Verify the 24-hour login link (?token=...)
//   useEffect(() => {
//     const token = new URLSearchParams(location.search).get("token");
//     if (!token) return;

//     const verifyLink = async () => {
//       try {
//         const response = await fetch(
//           `${DJANGO_API}/api/verify_login_link/?token=${encodeURIComponent(token)}`
//         );
//         const data = await response.json().catch(() => ({}));

//         if (response.ok && data.valid) {
//           setMode("login");
//           setFormData((prev) => ({ ...prev, username: data.email }));
//         } else {
//           setLinkInactive(true); // expired or invalid
//         }
//       } catch (error) {
//         setLinkInactive(true);
//       } finally {
//         setVerifyingLink(false);
//       }
//     };

//     verifyLink();
//   }, [location.search, DJANGO_API]);

//   // ---------- Validation ----------
//   const validateField = (name, value, data = formData) => {
//     switch (name) {
//       case "username":
//         if (!value.trim()) return "Email is required";
//         if (!EMAIL_REGEX.test(value)) return "Enter a valid email address";
//         return "";
//       case "password":
//         if (!value.trim()) return "Password is required";
//         return "";
//       case "first_name":
//         return isSignup && !value.trim() ? "First name is required" : "";
//       case "last_name":
//         return isSignup && !value.trim() ? "Last name is required" : "";
//       case "phone_no":
//         if (!isSignup) return "";
//         if (!value.trim()) return "Phone number is required";
//         if (!PHONE_REGEX.test(value.trim()))
//           return "Enter a valid phone number (10-14 digits)";
//         return "";
//       case "company_name":
//         return isSignup && !value.trim() ? "Company name is required" : "";
//       case "organization_type":
//         return isSignup && !value ? "Select organization type" : "";
//       case "company_address":
//         return isSignup && !value.trim() ? "Company address is required" : "";
//       case "implementation_priority":
//         return isSignup && !value ? "Select implementation priority" : "";
//       case "reference_by":
//         return isSignup && !value ? "Select a reference" : "";
//       case "reference_person_name":
//         return isSignup && data.reference_by === "Person" && !value.trim()
//           ? "Person name is required"
//           : "";
//       case "reference_person_mobile":
//         if (!isSignup || data.reference_by !== "Person") return "";
//         if (!value.trim()) return "Person mobile number is required";
//         if (!PHONE_REGEX.test(value.trim()))
//           return "Enter a valid phone number (10-14 digits)";
//         return "";
//       default:
//         return "";
//     }
//   };

//   const validate = () => {
//     const fields = isSignup
//       ? [
//           "first_name",
//           "last_name",
//           "username",
//           "phone_no",
//           "company_name",
//           "organization_type",
//           "company_address",
//           "implementation_priority",
//           "reference_by",
//           ...(formData.reference_by === "Person"
//             ? ["reference_person_name", "reference_person_mobile"]
//             : []),
//         ]
//       : ["username", "password"];

//     const newErrors = { ...emptyErrors };
//     fields.forEach((f) => {
//       newErrors[f] = validateField(f, formData[f], formData);
//     });
//     setErrors(newErrors);
//     return fields.every((f) => !newErrors[f]);
//   };

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     const updated = { ...formData, [name]: value };

//     // clear Person details when a different reference is chosen
//     if (name === "reference_by" && value !== "Person") {
//       updated.reference_person_name = "";
//       updated.reference_person_mobile = "";
//     }
//     setFormData(updated);

//     const newErrors = { ...errors, [name]: "", api: "" };
//     if (name === "reference_by" && value !== "Person") {
//       newErrors.reference_person_name = "";
//       newErrors.reference_person_mobile = "";
//     }

//     // live validation for email + phone fields
//     if (name === "username") newErrors.username = validateField(name, value);
//     if (isSignup && name === "phone_no")
//       newErrors.phone_no = validateField(name, value);
//     if (isSignup && name === "reference_person_mobile" && value)
//       newErrors.reference_person_mobile = validateField(name, value, updated);
//     setErrors(newErrors);
//     setSuccess("");
//   };

//   const switchMode = (_, newMode) => {
//     setMode(newMode);
//     setErrors(emptyErrors);
//     setSuccess("");
//     setShowPassword(false);
//     setOtp("");
//     setFormData((prev) => ({ ...prev, password: "" }));
//   };

//   // ---------- Login ----------
//   const fetchOrganization = async (token) => {
//     try {
//       const response = await fetch(`${DJANGO_API}/api/get_organization/`, {
//         method: "GET",
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });

//       const data = await response.json();
//       const customerId = data?.customers?.[0]?.id?.id;

//       if (customerId) {
//         localStorage.setItem("customer_id", customerId);
//       } else {
//         console.warn("No customer found in response");
//       }
//     } catch (error) {
//       console.error("Error fetching organization:", error);
//     }
//   };

//   const handleLogin = async () => {
//     const response = await fetch(`${DJANGO_API}/api/demo_login/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       // backend reads "email", not "username"
//       body: JSON.stringify({
//         email: formData.username.trim(),
//         password: formData.password,
//       }),
//     });

//     const data = await response.json();

//     if (!response.ok) {
//       setErrors((prev) => ({
//         ...prev,
//         api: data?.message || data?.error || "Invalid credentials",
//       }));
//       return;
//     }

//     const token = data.token;
//     if (!token) {
//       setErrors((prev) => ({ ...prev, api: "Token not received" }));
//       return;
//     }

//     localStorage.setItem("accessToken", token);

//     // session token + expiry used by SessionManager
//     if (data.session_token) {
//       localStorage.setItem("session_token", data.session_token);
//     }
//     if (data.expires_at) {
//       localStorage.setItem("session_expires_at", data.expires_at);
//     }

//     const decoded = jwtDecode(token);
//     localStorage.setItem("refreshToken", data.refreshToken);
//     // only save if present, so "undefined" is never stored
//     if (decoded.customerId) {
//       localStorage.setItem("customer_id", decoded.customerId);
//     }
//     localStorage.setItem("tenantId", decoded.tenantId);
//     localStorage.setItem("userId", decoded.userId);
//     // localStorage.setItem("userName", decoded.sub);
//     await fetchOrganization(token);

//     if (data.U_Type) {
//       localStorage.setItem("role", data.U_Type);
//     }

//     localStorage.setItem("session_welcome", "true");
//      localStorage.setItem("name", data.name);

//     navigate("/dashboard");
//   };

//   // ---------- Sign Up: step 1 - send OTP ----------
//   const handleSignup = async () => {
//     const response = await fetch(`${DJANGO_API}/api/send_otp/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         email: formData.username.trim(),
//         mobile: formData.phone_no.trim(),
//         name: formData.first_name.trim(),
//       }),
//     });

//     const data = await response.json().catch(() => ({}));

//     if (!response.ok) {
//       const isConflict = response.status === 409;
//       setErrors((prev) => ({
//         ...prev,
//         username: isConflict && data?.field !== "phone" ? data?.error || "" : "",
//         phone_no: isConflict && data?.field === "phone" ? data?.error || "" : "",
//         api: isConflict ? "" : data?.error || "Could not send OTP",
//       }));
//       return;
//     }

//     setOtp("");
//     setCooldown(OTP_RESEND_SECONDS);
//     setMode("otp");
//     setErrors(emptyErrors);
//     setSuccess(`We sent a 4-digit code to ${formData.phone_no.trim()}`);
//   };

//   // ---------- Sign Up: step 2 - verify OTP ----------
//   const handleVerifyOtp = async () => {
//     const response = await fetch(`${DJANGO_API}/api/verify_otp/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({ mobile: formData.phone_no.trim(), otp }),
//     });

//     const data = await response.json().catch(() => ({}));

//     if (!response.ok) {
//       setErrors((prev) => ({
//         ...prev,
//         api: data?.error || "Verification failed",
//       }));
//       return;
//     }

//     // Mobile verified -> create the account
//     await registerUser();
//   };

//   // ---------- Sign Up: step 3 - create the account ----------
//   const registerUser = async () => {
//     // Payload keys must match what the Django register view expects
//     const response = await fetch(`${DJANGO_API}/api/register/`, {
//       method: "POST",
//       headers: { "Content-Type": "application/json" },
//       body: JSON.stringify({
//         email: formData.username.trim(),
//         first_name: formData.first_name.trim(),
//         last_name: formData.last_name.trim(),
//         phone: formData.phone_no.trim(),
//         company_name: formData.company_name.trim(),
//         organization_type: formData.organization_type,
//         company_address: formData.company_address.trim(),
//         implementation_priority: formData.implementation_priority,
//         reference_by: formData.reference_by,
//         reference_person_name: formData.reference_person_name.trim(),
//         reference_person_mobile: formData.reference_person_mobile.trim(),
//       }),
//     });

//     let data = {};
//     try {
//       data = await response.json();
//     } catch (_) {
//       // response had no JSON body
//     }

//     if (!response.ok) {
//       // Backend returns { errors: { email: "...", phone: "...", ... } }
//       const errs = data?.errors || {};
//       const fieldErrors = {};
//       if (errs.email) fieldErrors.username = [].concat(errs.email).join(" ");
//       if (errs.first_name)
//         fieldErrors.first_name = [].concat(errs.first_name).join(" ");
//       if (errs.last_name)
//         fieldErrors.last_name = [].concat(errs.last_name).join(" ");
//       const phoneErr = errs.phone || errs.phone_no;
//       if (phoneErr) fieldErrors.phone_no = [].concat(phoneErr).join(" ");

//       [
//         "company_name",
//         "organization_type",
//         "company_address",
//         "implementation_priority",
//         "reference_by",
//         "reference_person_name",
//         "reference_person_mobile",
//       ].forEach((k) => {
//         if (errs[k]) fieldErrors[k] = [].concat(errs[k]).join(" ");
//       });

//       // go back to the form so field errors are visible
//       setMode("signup");
//       setOtp("");
//       setSuccess("");
//       setErrors((prev) => ({
//         ...prev,
//         ...fieldErrors,
//         api:
//           data?.message ||
//           data?.error ||
//           data?.detail ||
//           (Object.keys(fieldErrors).length ? "" : "Registration failed"),
//       }));
//       return;
//     }

//     // Success -> go back to Login with the email prefilled
//     setMode("login");
//     setOtp("");
//     setSuccess(
//       "Your Registration Succeeded! And demo portal login credentials has been sent to your email."
//     );
//     setFormData((prev) => ({ ...emptyForm, username: prev.username }));
//     setErrors(emptyErrors);
//   };

//   // ---------- Resend OTP ----------
//   const handleResendOtp = async () => {
//     if (cooldown > 0 || loading) return;
//     setErrors(emptyErrors);
//     setSuccess("");
//     setLoading(true);

//     try {
//       const response = await fetch(`${DJANGO_API}/api/resend_otp/`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           mobile: formData.phone_no.trim(),
//           name: formData.first_name.trim(),
//         }),
//       });
//       const data = await response.json().catch(() => ({}));

//       if (!response.ok) {
//         setErrors((prev) => ({
//           ...prev,
//           api: data?.error || "Could not resend OTP",
//         }));
//         return;
//       }

//       setOtp("");
//       setCooldown(OTP_RESEND_SECONDS);
//       setSuccess("A new code has been sent to your phone");
//     } catch (error) {
//       setErrors((prev) => ({ ...prev, api: "Unable to connect to server" }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (isOtp) {
//       if (!/^\d{4}$/.test(otp)) {
//         setErrors((prev) => ({ ...prev, api: "Enter the 4-digit code" }));
//         return;
//       }
//     } else if (!validate()) {
//       return;
//     }

//     setLoading(true);
//     setSuccess("");

//     try {
//       if (isOtp) {
//         await handleVerifyOtp();
//       } else if (isSignup) {
//         await handleSignup();
//       } else {
//         await handleLogin();
//       }
//     } catch (error) {
//       setErrors((prev) => ({ ...prev, api: "Unable to connect to server" }));
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fieldSx = { mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } };
//   const selectSx = { ...fieldSx, textAlign: "left" };

//   const passwordAdornment = (visible, toggle) => ({
//     endAdornment: (
//       <InputAdornment position="end">
//         <IconButton onClick={toggle} edge="end">
//           {visible ? <VisibilityOff /> : <Visibility />}
//         </IconButton>
//       </InputAdornment>
//     ),
//   });

//   const submitLabel = () => {
//     if (isOtp) return loading ? "Verifying..." : "Verify & register";
//     if (isSignup) return loading ? "Sending OTP..." : "Send OTP";
//     return loading ? "Verifying..." : "Login";
//   };

//   if (verifyingLink) return null;

//   if (linkInactive) {
//     return (
//       <Box
//         sx={{
//           minHeight: "100vh",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//           padding: 2,
//         }}
//       >
//         <Paper
//           elevation={20}
//           sx={{
//             width: "100%",
//             maxWidth: 440,
//             p: 4,
//             borderRadius: 4,
//             textAlign: "center",
//             bgcolor: "rgba(255, 255, 255, 0.9)",
//           }}
//         >
//           <img
//             src={process.env.PUBLIC_URL + "/IgnisVigilLogo_1.png"}
//             alt="Ignis Vigil Logo"
//             style={{ width: "200px", height: "100px", objectFit: "cover" }}
//           />
//           <Typography variant="h6" fontWeight="700" sx={{ mt: 2, mb: 1 }}>
//             This link is not active now
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             This login link has expired. For further assistance, please contact
//             our Sales Team.
//           </Typography>
//         </Paper>
//       </Box>
//     );
//   }

//   // ---------- UI ----------
//   return (
//     <Box
//       sx={{
//         minHeight: "100vh",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
//         padding: 2,
//       }}
//     >
//       {/* Session expired popup */}
//       <Dialog
//         open={sessionDialog}
//         onClose={() => setSessionDialog(false)}
//         PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
//       >
//         <DialogTitle sx={{ fontWeight: 700 }}>Session expired</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Your session is expired. Thank you for showing interest in our Demo.
//             For further assistance contact to our Sales Team.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button
//             variant="contained"
//             onClick={() => setSessionDialog(false)}
//             autoFocus
//             sx={{ textTransform: "none", borderRadius: 2 }}
//           >
//             OK
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <Paper
//         elevation={20}
//         sx={{
//           width: "100%",
//           maxWidth: 440,
//           p: 3,
//           borderRadius: 4,
//           textAlign: "center",
//           bgcolor: "rgba(255, 255, 255, 0.9)",
//           backdropFilter: "blur(10px)",
//           maxHeight: "95vh",
//           overflowY: "auto",
//         }}
//       >
//         <Box sx={{ textAlign: "center", mb: 2 }}>
//           <img
//             src={process.env.PUBLIC_URL + "/IgnisVigilLogo_1.png"}
//             alt="Ignis Vigil Logo"
//             style={{
//               width: "200px",
//               height: "100px",
//               objectFit: "cover",
//               objectPosition: "center",
//             }}
//           />
//         </Box>

//         <Typography variant="h6" fontWeight="700" sx={{ mt: 2, mb: 2 }}>
//           IoT & Smart Fire Fighting Systems Monitoring
//         </Typography>

//         {/* Login / Register switch (hidden while entering the OTP) */}
//         {!isOtp && (
//           <Tabs
//             value={mode}
//             onChange={switchMode}
//             variant="fullWidth"
//             sx={{
//               mb: 3,
//               borderBottom: 1,
//               borderColor: "divider",
//               "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
//             }}
//           >
//             <Tab value="signup" label="Register" />
//             <Tab value="login" label="Login" />
//           </Tabs>
//         )}

//         {isOtp && (
//           <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 2 }}>
//             Verify your OTP
//           </Typography>
//         )}

//         {success && (
//           <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }}>
//             {success}
//           </Alert>
//         )}

//         {errors.api && (
//           <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
//             {errors.api}
//           </Alert>
//         )}

//         <form onSubmit={handleSubmit} noValidate>
//           {isOtp ? (
//             <>
//               <TextField
//                 fullWidth
//                 label="Enter 4-digit code"
//                 name="otp"
//                 value={otp}
//                 onChange={(e) => {
//                   setOtp(e.target.value.replace(/\D/g, "").slice(0, 4));
//                   setErrors((prev) => ({ ...prev, api: "" }));
//                 }}
//                 inputProps={{
//                   inputMode: "numeric",
//                   autoComplete: "one-time-code",
//                   maxLength: 4,
//                   style: {
//                     letterSpacing: 8,
//                     textAlign: "center",
//                     fontSize: 22,
//                   },
//                 }}
//                 autoFocus
//                 sx={fieldSx}
//               />

//               <Typography
//                 variant="body2"
//                 sx={{ mb: 3, color: "text.secondary" }}
//               >
//                 {cooldown > 0 ? (
//                   `Resend code in ${cooldown}s`
//                 ) : (
//                   <Box
//                     component="span"
//                     onClick={handleResendOtp}
//                     sx={{
//                       color: "primary.main",
//                       fontWeight: 600,
//                       cursor: "pointer",
//                     }}
//                   >
//                     Resend code
//                   </Box>
//                 )}
//               </Typography>
//             </>
//           ) : (
//             <>
//               {isSignup && (
//                 <Box sx={{ display: "flex", gap: 2 }}>
//                   <TextField
//                     fullWidth
//                     label="First name"
//                     name="first_name"
//                     value={formData.first_name}
//                     onChange={handleChange}
//                     error={!!errors.first_name}
//                     helperText={errors.first_name}
//                     inputProps={{ maxLength: 100 }}
//                     sx={fieldSx}
//                   />
//                   <TextField
//                     fullWidth
//                     label="Last name"
//                     name="last_name"
//                     value={formData.last_name}
//                     onChange={handleChange}
//                     error={!!errors.last_name}
//                     helperText={errors.last_name}
//                     inputProps={{ maxLength: 100 }}
//                     sx={fieldSx}
//                   />
//                 </Box>
//               )}

//               <TextField
//                 fullWidth
//                 label="Email"
//                 name="username"
//                 variant="outlined"
//                 value={formData.username}
//                 onChange={handleChange}
//                 error={!!errors.username}
//                 helperText={errors.username}
//                 sx={fieldSx}
//               />

//               {isSignup && (
//                 <TextField
//                   fullWidth
//                   label="Phone number"
//                   name="phone_no"
//                   value={formData.phone_no}
//                   onChange={handleChange}
//                   error={!!errors.phone_no}
//                   helperText={errors.phone_no}
//                   inputProps={{ maxLength: 15, inputMode: "tel" }}
//                   sx={fieldSx}
//                 />
//               )}

//               {/* ---- New registration fields ---- */}
//               {isSignup && (
//                 <>
//                   <TextField
//                     fullWidth
//                     label="Company name"
//                     name="company_name"
//                     value={formData.company_name}
//                     onChange={handleChange}
//                     error={!!errors.company_name}
//                     helperText={errors.company_name}
//                     inputProps={{ maxLength: 200 }}
//                     sx={fieldSx}
//                   />

//                   <TextField
//                     select
//                     fullWidth
//                     label="Organization type"
//                     name="organization_type"
//                     value={formData.organization_type}
//                     onChange={handleChange}
//                     error={!!errors.organization_type}
//                     helperText={errors.organization_type}
//                     sx={selectSx}
//                   >
//                     {ORG_TYPES.map((o) => (
//                       <MenuItem key={o} value={o}>
//                         {o}
//                       </MenuItem>
//                     ))}
//                   </TextField>

//                   <TextField
//                     fullWidth
//                     multiline
//                     minRows={2}
//                     label="Company address"
//                     name="company_address"
//                     value={formData.company_address}
//                     onChange={handleChange}
//                     error={!!errors.company_address}
//                     helperText={errors.company_address}
//                     sx={fieldSx}
//                   />

//                   <TextField
//                     select
//                     fullWidth
//                     label="Implementation priority"
//                     name="implementation_priority"
//                     value={formData.implementation_priority}
//                     onChange={handleChange}
//                     error={!!errors.implementation_priority}
//                     helperText={errors.implementation_priority}
//                     sx={selectSx}
//                   >
//                     {PRIORITIES.map((p) => (
//                       <MenuItem key={p} value={p}>
//                         {p}
//                       </MenuItem>
//                     ))}
//                   </TextField>

//                   <TextField
//                     select
//                     fullWidth
//                     label="Reference by"
//                     name="reference_by"
//                     value={formData.reference_by}
//                     onChange={handleChange}
//                     error={!!errors.reference_by}
//                     helperText={errors.reference_by}
//                     sx={selectSx}
//                   >
//                     {REFERENCES.map((r) => (
//                       <MenuItem key={r} value={r}>
//                         {r}
//                       </MenuItem>
//                     ))}
//                   </TextField>

//                   {formData.reference_by === "Person" && (
//                     <Box sx={{ display: "flex", gap: 2 }}>
//                       <TextField
//                         fullWidth
//                         label="Person name"
//                         name="reference_person_name"
//                         value={formData.reference_person_name}
//                         onChange={handleChange}
//                         error={!!errors.reference_person_name}
//                         helperText={errors.reference_person_name}
//                         inputProps={{ maxLength: 100 }}
//                         sx={fieldSx}
//                       />
//                       <TextField
//                         fullWidth
//                         label="Person mobile"
//                         name="reference_person_mobile"
//                         value={formData.reference_person_mobile}
//                         onChange={handleChange}
//                         error={!!errors.reference_person_mobile}
//                         helperText={errors.reference_person_mobile}
//                         inputProps={{ maxLength: 15, inputMode: "tel" }}
//                         sx={fieldSx}
//                       />
//                     </Box>
//                   )}
//                 </>
//               )}

//               {!isSignup && (
//                 <TextField
//                   fullWidth
//                   label="Password"
//                   name="password"
//                   type={showPassword ? "text" : "password"}
//                   value={formData.password}
//                   onChange={handleChange}
//                   error={!!errors.password}
//                   helperText={errors.password}
//                   sx={{ ...fieldSx, mb: 1 }}
//                   InputProps={passwordAdornment(showPassword, () =>
//                     setShowPassword(!showPassword)
//                   )}
//                 />
//               )}

//               {!isSignup && (
//                 <Typography
//                   variant="caption"
//                   sx={{
//                     display: "block",
//                     textAlign: "right",
//                     mb: 3,
//                     cursor: "pointer",
//                     color: "primary.main",
//                     fontWeight: 600,
//                   }}
//                 >
//                   Forgot password?
//                 </Typography>
//               )}
//             </>
//           )}

//           <Button
//             fullWidth
//             variant="contained"
//             type="submit"
//             disabled={loading}
//             sx={{
//               py: 1.5,
//               borderRadius: 2,
//               textTransform: "none",
//               fontSize: "1rem",
//               fontWeight: 600,
//               boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
//               transition: "all 0.3s ease",
//               "&:hover": {
//                 transform: "translateY(-2px)",
//                 boxShadow: "0px 12px 20px rgba(0, 0, 0, 0.15)",
//               },
//             }}
//           >
//             {submitLabel()}
//           </Button>
//         </form>

//         {isOtp ? (
//           <Typography variant="body2" sx={{ mt: 3, color: "text.secondary" }}>
//             Wrong number?{" "}
//             <Box
//               component="span"
//               onClick={() => switchMode(null, "signup")}
//               sx={{ color: "primary.main", fontWeight: 600, cursor: "pointer" }}
//             >
//               Go back
//             </Box>
//           </Typography>
//         ) : (
//           <Typography variant="body2" sx={{ mt: 3, color: "text.secondary" }}>
//             {isSignup ? "Already have an account? " : "New here? "}
//             <Box
//               component="span"
//               onClick={() => switchMode(null, isSignup ? "login" : "signup")}
//               sx={{ color: "primary.main", fontWeight: 600, cursor: "pointer" }}
//             >
//               {isSignup ? "Login" : "Register"}
//             </Box>
//           </Typography>
//         )}
//       </Paper>
//     </Box>
//   );
// }

// export default Login;








import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Alert,
  IconButton,
  InputAdornment,
  Paper,
  Tabs,
  Tab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  MenuItem,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

// ---------- Validation rules ----------
// Email: no spaces, no leading/trailing dot in the local part, valid domain + TLD
const EMAIL_REGEX =
  /^[A-Za-z0-9](?:[A-Za-z0-9._%+-]*[A-Za-z0-9])?@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;
// Phone: optional leading +, 10-14 digits (fits CharField(max_length=15))
const PHONE_REGEX = /^\+?[0-9]{10}$/;
// Person names: letters (any language), space, dot, apostrophe, hyphen. Must start with a letter
const NAME_REGEX = /^\p{L}[\p{L} .'-]*$/u;
// Company name: letters, digits, space and & . , ' ( ) / -  (must start with letter/digit)
const COMPANY_REGEX = /^[\p{L}\p{N}][\p{L}\p{N} &.,'()/-]*$/u;
// Address: letters, digits, space, new line and , . - / # ( ) & ' : ;
const ADDRESS_REGEX = /^[\p{L}\p{N}][\p{L}\p{N} \n,.\-/#()&':;]*$/u;

const OTP_RESEND_SECONDS = 60;

const ORG_TYPES = [
  "Builder",
  "MEP Consultant",
  "System Integrator",
  "Supplier",
  "Auditor",
];
const PRIORITIES = ["Immediate", "Within 1 Month", "Within 3 Months"];
const REFERENCES = ["Internet", "WhatsApp", "Person"];

// ---------- Input sanitizers (run while typing) ----------
// remove leading spaces and collapse repeated spaces (trailing space is trimmed on blur,
// because a space is needed temporarily between words while typing)
const tidySpaces = (v) => v.replace(/^\s+/, "").replace(/\s{2,}/g, " ");

const sanitizePhone = (v) => {
  const cleaned = v.replace(/[^\d+]/g, "");
  const plus = cleaned.startsWith("+") ? "+" : "";
  return plus + cleaned.replace(/\+/g, "");
};

const sanitizers = {
  // no spaces at all
  username: (v) => v.replace(/\s/g, ""),
  password: (v) => v.replace(/\s/g, ""),
  // letters only
  first_name: (v) => tidySpaces(v.replace(/[^\p{L} .'-]/gu, "")),
  last_name: (v) => tidySpaces(v.replace(/[^\p{L} .'-]/gu, "")),
  reference_person_name: (v) => tidySpaces(v.replace(/[^\p{L} .'-]/gu, "")),
  // digits and a leading +
  phone_no: sanitizePhone,
  reference_person_mobile: sanitizePhone,
  company_name: (v) => tidySpaces(v.replace(/[^\p{L}\p{N} &.,'()/-]/gu, "")),
  company_address: (v) =>
    v
      .replace(/^\s+/, "")
      .replace(/[ \t]{2,}/g, " ")
      .replace(/\n{3,}/g, "\n\n")
      .replace(/[^\p{L}\p{N} \n,.\-/#()&':;]/gu, ""),
};

const emptyErrors = {
  username: "",
  password: "",
  first_name: "",
  last_name: "",
  phone_no: "",
  company_name: "",
  organization_type: "",
  company_address: "",
  implementation_priority: "",
  reference_by: "",
  reference_person_name: "",
  reference_person_mobile: "",
  api: "",
};

const emptyForm = {
  username: "", // email
  password: "",
  first_name: "",
  last_name: "",
  phone_no: "",
  company_name: "",
  organization_type: "",
  company_address: "",
  implementation_priority: "",
  reference_by: "",
  reference_person_name: "",
  reference_person_mobile: "",
};

// ---------- Reusable validators ----------
const validateName = (value, label, min = 2) => {
  const v = value.trim();
  if (!v) return `${label} is required`;
  if (v.length < min) return `${label} must be at least ${min} characters`;
  if (v.length > 100) return `${label} must be at most 100 characters`;
  if (!NAME_REGEX.test(v))
    return `${label} can contain only letters, spaces, . ' -`;
  return "";
};

const validatePhone = (value, label) => {
  const v = value.trim();
  if (!v) return `${label} is required`;
  if (!PHONE_REGEX.test(v)) return "Enter a valid phone number (10 digits)";
  // 10-digit Indian mobile numbers start with 6, 7, 8 or 9
  if (!v.startsWith("+") && v.length === 10 && !/^[6-9]/.test(v))
    return "Mobile number must start with 6, 7, 8 or 9";
  return "";
};

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const DJANGO_API = process.env.REACT_APP_API_DJANGO_URL;

  // "login" | "signup" | "otp"
  const [mode, setMode] = useState("login");
  const isSignup = mode === "signup";
  const isOtp = mode === "otp";

  const [formData, setFormData] = useState(emptyForm);

  const [errors, setErrors] = useState(emptyErrors);
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // OTP state
  const [otp, setOtp] = useState("");
  const [cooldown, setCooldown] = useState(0);

  // Session-expired popup
  const [sessionDialog, setSessionDialog] = useState(false);
  // 24-hour login link state
  const [linkInactive, setLinkInactive] = useState(false);
  const [verifyingLink, setVerifyingLink] = useState(
    () => !!new URLSearchParams(window.location.search).get("token")
  );

  // Open the popup when SessionManager redirected here because of expiry
  useEffect(() => {
    if (location.state?.sessionExpired) {
      setSessionDialog(true);
      // clear the router state so the popup doesn't reappear on refresh
      navigate(location.pathname, { replace: true, state: null });
    }
  }, [location.state, location.pathname, navigate]);

  // Resend countdown
  useEffect(() => {
    if (cooldown <= 0) return undefined;
    const t = setTimeout(() => setCooldown((c) => c - 1), 1000);
    return () => clearTimeout(t);
  }, [cooldown]);

  // Verify the 24-hour login link (?token=...)
  useEffect(() => {
    const token = new URLSearchParams(location.search).get("token");
    if (!token) return;

    const verifyLink = async () => {
      try {
        const response = await fetch(
          `${DJANGO_API}/api/verify_login_link/?token=${encodeURIComponent(token)}`
        );
        const data = await response.json().catch(() => ({}));

        if (response.ok && data.valid) {
          setMode("login");
          setFormData((prev) => ({ ...prev, username: data.email }));
        } else {
          setLinkInactive(true); // expired or invalid
        }
      } catch (error) {
        setLinkInactive(true);
      } finally {
        setVerifyingLink(false);
      }
    };

    verifyLink();
  }, [location.search, DJANGO_API]);

  // ---------- Validation ----------
  const validateField = (name, value, data = formData) => {
    const v = (value || "").trim();

    switch (name) {
      case "username":
        if (!v) return "Email is required";
        if (v.length > 254) return "Email is too long";
        if (v.includes("..") || !EMAIL_REGEX.test(v))
          return "Enter a valid email address";
        return "";
      case "password":
        if (!value) return "Password is required";
        return "";
      case "first_name":
        return isSignup ? validateName(value, "First name", 2) : "";
      case "last_name":
        return isSignup ? validateName(value, "Last name", 1) : "";
      case "phone_no":
        return isSignup ? validatePhone(value, "Phone number") : "";
      case "company_name":
        if (!isSignup) return "";
        if (!v) return "Company name is required";
        if (v.length < 2) return "Company name must be at least 2 characters";
        if (v.length > 200) return "Company name must be at most 200 characters";
        if (!COMPANY_REGEX.test(v))
          return "Company name can contain only letters, numbers, spaces and & . , ' ( ) / -";
        return "";
      case "organization_type":
        return isSignup && !value ? "Select organization type" : "";
      case "company_address":
        if (!isSignup) return "";
        if (!v) return "Company address is required";
        if (v.length < 10) return "Enter the complete company address";
        if (v.length > 500) return "Address must be at most 500 characters";
        if (!ADDRESS_REGEX.test(v))
          return "Address contains invalid characters";
        return "";
      case "implementation_priority":
        return isSignup && !value ? "Select implementation priority" : "";
      case "reference_by":
        return isSignup && !value ? "Select a reference" : "";
      case "reference_person_name":
        return isSignup && data.reference_by === "Person"
          ? validateName(value, "Person name", 2)
          : "";
      case "reference_person_mobile":
        return isSignup && data.reference_by === "Person"
          ? validatePhone(value, "Person mobile number")
          : "";
      default:
        return "";
    }
  };

  const validate = (data = formData) => {
    const fields = isSignup
      ? [
          "first_name",
          "last_name",
          "username",
          "phone_no",
          "company_name",
          "organization_type",
          "company_address",
          "implementation_priority",
          "reference_by",
          ...(data.reference_by === "Person"
            ? ["reference_person_name", "reference_person_mobile"]
            : []),
        ]
      : ["username", "password"];

    const newErrors = { ...emptyErrors };
    fields.forEach((f) => {
      newErrors[f] = validateField(f, data[f], data);
    });
    setErrors(newErrors);
    return fields.every((f) => !newErrors[f]);
  };

  const handleChange = (e) => {
    const { name, value: rawValue } = e.target;

    // block leading spaces / invalid characters while typing
    const sanitize = sanitizers[name];
    const value = sanitize ? sanitize(rawValue) : rawValue;

    const updated = { ...formData, [name]: value };

    // clear Person details when a different reference is chosen
    if (name === "reference_by" && value !== "Person") {
      updated.reference_person_name = "";
      updated.reference_person_mobile = "";
    }
    setFormData(updated);

    const newErrors = { ...errors, [name]: "", api: "" };
    if (name === "reference_by" && value !== "Person") {
      newErrors.reference_person_name = "";
      newErrors.reference_person_mobile = "";
    }

    // live validation for email + phone fields
    if (name === "username") newErrors.username = validateField(name, value);
    if (isSignup && name === "phone_no")
      newErrors.phone_no = validateField(name, value);
    if (isSignup && name === "reference_person_mobile" && value)
      newErrors.reference_person_mobile = validateField(name, value, updated);
    setErrors(newErrors);
    setSuccess("");
  };

  // trim trailing/leading spaces when the user leaves the field, then validate it
  const handleBlur = (e) => {
    if (isOtp) return;
    const { name, value } = e.target;
    const trimmed = value.trim();
    const updated = { ...formData, [name]: trimmed };

    if (trimmed !== value) setFormData(updated);

    // in login mode only email + password are relevant
    if (!isSignup && name !== "username" && name !== "password") return;

    setErrors((prev) => ({
      ...prev,
      [name]: validateField(name, trimmed, updated),
    }));
  };

  const switchMode = (_, newMode) => {
    setMode(newMode);
    setErrors(emptyErrors);
    setSuccess("");
    setShowPassword(false);
    setOtp("");
    setFormData((prev) => ({ ...prev, password: "" }));
  };

  // shared props for plain text inputs
  const bind = (name) => ({
    name,
    value: formData[name],
    onChange: handleChange,
    onBlur: handleBlur,
    error: !!errors[name],
    helperText: errors[name],
  });

  // ---------- Login ----------
  const fetchOrganization = async (token) => {
    try {
      const response = await fetch(`${DJANGO_API}/api/get_organization/`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await response.json();
      const customerId = data?.customers?.[0]?.id?.id;

      if (customerId) {
        localStorage.setItem("customer_id", customerId);
      } else {
        console.warn("No customer found in response");
      }
    } catch (error) {
      console.error("Error fetching organization:", error);
    }
  };

  const handleLogin = async () => {
    const response = await fetch(`${DJANGO_API}/api/demo_login/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      // backend reads "email", not "username"
      body: JSON.stringify({
        email: formData.username.trim(),
        password: formData.password,
      }),
    });

    const data = await response.json();

    if (!response.ok) {
      setErrors((prev) => ({
        ...prev,
        api: data?.message || data?.error || "Invalid credentials",
      }));
      return;
    }

    const token = data.token;
    if (!token) {
      setErrors((prev) => ({ ...prev, api: "Token not received" }));
      return;
    }

    localStorage.setItem("accessToken", token);

    // session token + expiry used by SessionManager
    if (data.session_token) {
      localStorage.setItem("session_token", data.session_token);
    }
    if (data.expires_at) {
      localStorage.setItem("session_expires_at", data.expires_at);
    }

    const decoded = jwtDecode(token);
    localStorage.setItem("refreshToken", data.refreshToken);
    // only save if present, so "undefined" is never stored
    if (decoded.customerId) {
      localStorage.setItem("customer_id", decoded.customerId);
    }
    localStorage.setItem("tenantId", decoded.tenantId);
    localStorage.setItem("userId", decoded.userId);
    // localStorage.setItem("userName", decoded.sub);
    await fetchOrganization(token);

    if (data.U_Type) {
      localStorage.setItem("role", data.U_Type);
    }

    localStorage.setItem("session_welcome", "true");
    localStorage.setItem("name", data.name);

    navigate("/dashboard");
  };

  // ---------- Sign Up: step 1 - send OTP ----------
  const handleSignup = async () => {
    const response = await fetch(`${DJANGO_API}/api/send_otp/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: formData.username.trim(),
        mobile: formData.phone_no.trim(),
        name: formData.first_name.trim(),
      }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      const isConflict = response.status === 409;
      setErrors((prev) => ({
        ...prev,
        username: isConflict && data?.field !== "phone" ? data?.error || "" : "",
        phone_no: isConflict && data?.field === "phone" ? data?.error || "" : "",
        api: isConflict ? "" : data?.error || "Could not send OTP",
      }));
      return;
    }

    setOtp("");
    setCooldown(OTP_RESEND_SECONDS);
    setMode("otp");
    setErrors(emptyErrors);
    setSuccess(`We sent a 4-digit code to ${formData.phone_no.trim()}`);
  };

  // ---------- Sign Up: step 2 - verify OTP ----------
  const handleVerifyOtp = async () => {
    const response = await fetch(`${DJANGO_API}/api/verify_otp/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mobile: formData.phone_no.trim(), otp }),
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      setErrors((prev) => ({
        ...prev,
        api: data?.error || "Verification failed",
      }));
      return;
    }

    // Mobile verified -> create the account
    await registerUser();
  };

  // ---------- Sign Up: step 3 - create the account ----------
  const registerUser = async () => {
    // Payload keys must match what the Django register view expects
    const response = await fetch(`${DJANGO_API}/api/register/`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: formData.username.trim(),
        first_name: formData.first_name.trim(),
        last_name: formData.last_name.trim(),
        phone: formData.phone_no.trim(),
        company_name: formData.company_name.trim(),
        organization_type: formData.organization_type,
        company_address: formData.company_address.trim(),
        implementation_priority: formData.implementation_priority,
        reference_by: formData.reference_by,
        reference_person_name: formData.reference_person_name.trim(),
        reference_person_mobile: formData.reference_person_mobile.trim(),
      }),
    });

    let data = {};
    try {
      data = await response.json();
    } catch (_) {
      // response had no JSON body
    }

    if (!response.ok) {
      // Backend returns { errors: { email: "...", phone: "...", ... } }
      const errs = data?.errors || {};
      const fieldErrors = {};
      if (errs.email) fieldErrors.username = [].concat(errs.email).join(" ");
      if (errs.first_name)
        fieldErrors.first_name = [].concat(errs.first_name).join(" ");
      if (errs.last_name)
        fieldErrors.last_name = [].concat(errs.last_name).join(" ");
      const phoneErr = errs.phone || errs.phone_no;
      if (phoneErr) fieldErrors.phone_no = [].concat(phoneErr).join(" ");

      [
        "company_name",
        "organization_type",
        "company_address",
        "implementation_priority",
        "reference_by",
        "reference_person_name",
        "reference_person_mobile",
      ].forEach((k) => {
        if (errs[k]) fieldErrors[k] = [].concat(errs[k]).join(" ");
      });

      // go back to the form so field errors are visible
      setMode("signup");
      setOtp("");
      setSuccess("");
      setErrors((prev) => ({
        ...prev,
        ...fieldErrors,
        api:
          data?.message ||
          data?.error ||
          data?.detail ||
          (Object.keys(fieldErrors).length ? "" : "Registration failed"),
      }));
      return;
    }

    // Success -> go back to Login with the email prefilled
    setMode("login");
    setOtp("");
    setSuccess(
      "Your Registration Succeeded! And demo portal login credentials has been sent to your email."
    );
    setFormData((prev) => ({ ...emptyForm, username: prev.username }));
    setErrors(emptyErrors);
  };

  // ---------- Resend OTP ----------
  const handleResendOtp = async () => {
    if (cooldown > 0 || loading) return;
    setErrors(emptyErrors);
    setSuccess("");
    setLoading(true);

    try {
      const response = await fetch(`${DJANGO_API}/api/resend_otp/`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          mobile: formData.phone_no.trim(),
          name: formData.first_name.trim(),
        }),
      });
      const data = await response.json().catch(() => ({}));

      if (!response.ok) {
        setErrors((prev) => ({
          ...prev,
          api: data?.error || "Could not resend OTP",
        }));
        return;
      }

      setOtp("");
      setCooldown(OTP_RESEND_SECONDS);
      setSuccess("A new code has been sent to your phone");
    } catch (error) {
      setErrors((prev) => ({ ...prev, api: "Unable to connect to server" }));
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isOtp) {
      if (!/^\d{4}$/.test(otp)) {
        setErrors((prev) => ({ ...prev, api: "Enter the 4-digit code" }));
        return;
      }
    } else {
      // trim every field before validating (covers pressing Enter without leaving the field)
      const trimmedForm = Object.fromEntries(
        Object.entries(formData).map(([k, v]) => [k, v.trim()])
      );
      setFormData(trimmedForm);

      if (!validate(trimmedForm)) return;
    }

    setLoading(true);
    setSuccess("");

    try {
      if (isOtp) {
        await handleVerifyOtp();
      } else if (isSignup) {
        await handleSignup();
      } else {
        await handleLogin();
      }
    } catch (error) {
      setErrors((prev) => ({ ...prev, api: "Unable to connect to server" }));
    } finally {
      setLoading(false);
    }
  };

  const fieldSx = { mb: 2, "& .MuiOutlinedInput-root": { borderRadius: 2 } };
  const selectSx = { ...fieldSx, textAlign: "left" };

  const passwordAdornment = (visible, toggle) => ({
    endAdornment: (
      <InputAdornment position="end">
        <IconButton onClick={toggle} edge="end">
          {visible ? <VisibilityOff /> : <Visibility />}
        </IconButton>
      </InputAdornment>
    ),
  });

  const submitLabel = () => {
    if (isOtp) return loading ? "Verifying..." : "Verify & register";
    if (isSignup) return loading ? "Sending OTP..." : "Send OTP";
    return loading ? "Verifying..." : "Login";
  };

  if (verifyingLink) return null;

  if (linkInactive) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
          padding: 2,
        }}
      >
        <Paper
          elevation={20}
          sx={{
            width: "100%",
            maxWidth: 440,
            p: 4,
            borderRadius: 4,
            textAlign: "center",
            bgcolor: "rgba(255, 255, 255, 0.9)",
          }}
        >
          <img
            src={process.env.PUBLIC_URL + "/IgnisVigilLogo_1.png"}
            alt="Ignis Vigil Logo"
            style={{ width: "200px", height: "100px", objectFit: "cover" }}
          />
          <Typography variant="h6" fontWeight="700" sx={{ mt: 2, mb: 1 }}>
            This link is not active now
          </Typography>
          <Typography variant="body2" color="text.secondary">
            This login link has expired. For further assistance, please contact
            our Sales Team.
          </Typography>
        </Paper>
      </Box>
    );
  }

  // ---------- UI ----------
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        padding: 2,
      }}
    >
      {/* Session expired popup */}
      <Dialog
        open={sessionDialog}
        onClose={() => setSessionDialog(false)}
        PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
      >
        <DialogTitle sx={{ fontWeight: 700 }}>Session expired</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Your session is expired. Thank you for showing interest in our Demo.
            For further assistance contact to our Sales Team.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => setSessionDialog(false)}
            autoFocus
            sx={{ textTransform: "none", borderRadius: 2 }}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>

      <Paper
        elevation={20}
        sx={{
          width: "100%",
          maxWidth: 440,
          p: 3,
          borderRadius: 4,
          textAlign: "center",
          bgcolor: "rgba(255, 255, 255, 0.9)",
          backdropFilter: "blur(10px)",
          maxHeight: "95vh",
          overflowY: "auto",
        }}
      >
        <Box sx={{ textAlign: "center", mb: 2 }}>
          <img
            src={process.env.PUBLIC_URL + "/IgnisVigilLogo_1.png"}
            alt="Ignis Vigil Logo"
            style={{
              width: "200px",
              height: "100px",
              objectFit: "cover",
              objectPosition: "center",
            }}
          />
        </Box>

        <Typography variant="h6" fontWeight="700" sx={{ mt: 2, mb: 2 }}>
          IoT & Smart Fire Fighting Systems Monitoring
        </Typography>

        {/* Login / Register switch (hidden while entering the OTP) */}
        {!isOtp && (
          <Tabs
            value={mode}
            onChange={switchMode}
            variant="fullWidth"
            sx={{
              mb: 3,
              borderBottom: 1,
              borderColor: "divider",
              "& .MuiTab-root": { textTransform: "none", fontWeight: 600 },
            }}
          >
            <Tab value="signup" label="Register" />
            <Tab value="login" label="Login" />
          </Tabs>
        )}

        {isOtp && (
          <Typography variant="subtitle1" fontWeight="600" sx={{ mb: 2 }}>
            Verify your OTP
          </Typography>
        )}

        {success && (
          <Alert severity="success" sx={{ mb: 3, borderRadius: 2 }}>
            {success}
          </Alert>
        )}

        {errors.api && (
          <Alert severity="error" sx={{ mb: 3, borderRadius: 2 }}>
            {errors.api}
          </Alert>
        )}

        <form onSubmit={handleSubmit} noValidate>
          {isOtp ? (
            <>
              <TextField
                fullWidth
                label="Enter 4-digit code"
                name="otp"
                value={otp}
                onChange={(e) => {
                  setOtp(e.target.value.replace(/\D/g, "").slice(0, 4));
                  setErrors((prev) => ({ ...prev, api: "" }));
                }}
                inputProps={{
                  inputMode: "numeric",
                  autoComplete: "one-time-code",
                  maxLength: 4,
                  style: {
                    letterSpacing: 8,
                    textAlign: "center",
                    fontSize: 22,
                  },
                }}
                autoFocus
                sx={fieldSx}
              />

              <Typography
                variant="body2"
                sx={{ mb: 3, color: "text.secondary" }}
              >
                {cooldown > 0 ? (
                  `Resend code in ${cooldown}s`
                ) : (
                  <Box
                    component="span"
                    onClick={handleResendOtp}
                    sx={{
                      color: "primary.main",
                      fontWeight: 600,
                      cursor: "pointer",
                    }}
                  >
                    Resend code
                  </Box>
                )}
              </Typography>
            </>
          ) : (
            <>
              {isSignup && (
                <Box sx={{ display: "flex", gap: 2 }}>
                  <TextField
                    fullWidth
                    label="First name"
                    {...bind("first_name")}
                    inputProps={{ maxLength: 100, autoComplete: "given-name" }}
                    sx={fieldSx}
                  />
                  <TextField
                    fullWidth
                    label="Last name"
                    {...bind("last_name")}
                    inputProps={{ maxLength: 100, autoComplete: "family-name" }}
                    sx={fieldSx}
                  />
                </Box>
              )}

              <TextField
                fullWidth
                label="Email"
                variant="outlined"
                {...bind("username")}
                inputProps={{
                  maxLength: 254,
                  autoComplete: "email",
                  inputMode: "email",
                  autoCapitalize: "none",
                  spellCheck: false,
                }}
                sx={fieldSx}
              />

              {isSignup && (
                <TextField
                  fullWidth
                  label="Phone number"
                  {...bind("phone_no")}
                  inputProps={{
                    maxLength: 15,
                    inputMode: "tel",
                    autoComplete: "tel",
                  }}
                  sx={fieldSx}
                />
              )}

              {/* ---- Additional registration fields ---- */}
              {isSignup && (
                <>
                  <TextField
                    fullWidth
                    label="Company name"
                    {...bind("company_name")}
                    inputProps={{ maxLength: 200, autoComplete: "organization" }}
                    sx={fieldSx}
                  />

                  <TextField
                    select
                    fullWidth
                    label="Organization type"
                    name="organization_type"
                    value={formData.organization_type}
                    onChange={handleChange}
                    error={!!errors.organization_type}
                    helperText={errors.organization_type}
                    sx={selectSx}
                  >
                    {ORG_TYPES.map((o) => (
                      <MenuItem key={o} value={o}>
                        {o}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    fullWidth
                    multiline
                    minRows={2}
                    label="Company address"
                    {...bind("company_address")}
                    inputProps={{ maxLength: 500 }}
                    sx={fieldSx}
                  />

                  <TextField
                    select
                    fullWidth
                    label="Implementation priority"
                    name="implementation_priority"
                    value={formData.implementation_priority}
                    onChange={handleChange}
                    error={!!errors.implementation_priority}
                    helperText={errors.implementation_priority}
                    sx={selectSx}
                  >
                    {PRIORITIES.map((p) => (
                      <MenuItem key={p} value={p}>
                        {p}
                      </MenuItem>
                    ))}
                  </TextField>

                  <TextField
                    select
                    fullWidth
                    label="Reference by"
                    name="reference_by"
                    value={formData.reference_by}
                    onChange={handleChange}
                    error={!!errors.reference_by}
                    helperText={errors.reference_by}
                    sx={selectSx}
                  >
                    {REFERENCES.map((r) => (
                      <MenuItem key={r} value={r}>
                        {r}
                      </MenuItem>
                    ))}
                  </TextField>

                  {formData.reference_by === "Person" && (
                    <Box sx={{ display: "flex", gap: 2 }}>
                      <TextField
                        fullWidth
                        label="Person name"
                        {...bind("reference_person_name")}
                        inputProps={{ maxLength: 100 }}
                        sx={fieldSx}
                      />
                      <TextField
                        fullWidth
                        label="Person mobile"
                        {...bind("reference_person_mobile")}
                        inputProps={{ maxLength: 15, inputMode: "tel" }}
                        sx={fieldSx}
                      />
                    </Box>
                  )}
                </>
              )}

              {!isSignup && (
                <TextField
                  fullWidth
                  label="Password"
                  type={showPassword ? "text" : "password"}
                  {...bind("password")}
                  inputProps={{ autoComplete: "current-password" }}
                  sx={{ ...fieldSx, mb: 1 }}
                  InputProps={passwordAdornment(showPassword, () =>
                    setShowPassword(!showPassword)
                  )}
                />
              )}

              {!isSignup && (
                <Typography
                  variant="caption"
                  sx={{
                    display: "block",
                    textAlign: "right",
                    mb: 3,
                    cursor: "pointer",
                    color: "primary.main",
                    fontWeight: 600,
                  }}
                >
                  Forgot password?
                </Typography>
              )}
            </>
          )}

          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={loading}
            sx={{
              py: 1.5,
              borderRadius: 2,
              textTransform: "none",
              fontSize: "1rem",
              fontWeight: 600,
              boxShadow: "0px 8px 15px rgba(0, 0, 0, 0.1)",
              transition: "all 0.3s ease",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0px 12px 20px rgba(0, 0, 0, 0.15)",
              },
            }}
          >
            {submitLabel()}
          </Button>
        </form>

        {isOtp ? (
          <Typography variant="body2" sx={{ mt: 3, color: "text.secondary" }}>
            Wrong number?{" "}
            <Box
              component="span"
              onClick={() => switchMode(null, "signup")}
              sx={{ color: "primary.main", fontWeight: 600, cursor: "pointer" }}
            >
              Go back
            </Box>
          </Typography>
        ) : (
          <Typography variant="body2" sx={{ mt: 3, color: "text.secondary" }}>
            {isSignup ? "Already have an account? " : "New here? "}
            <Box
              component="span"
              onClick={() => switchMode(null, isSignup ? "login" : "signup")}
              sx={{ color: "primary.main", fontWeight: 600, cursor: "pointer" }}
            >
              {isSignup ? "Login" : "Register"}
            </Box>
          </Typography>
        )}
      </Paper>
    </Box>
  );
}

export default Login;